var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "operateBtn",
    class: {
      'asRole': _vm.type == 'asRole'
    }
  }, [_c('el-popover', {
    attrs: {
      "title": "",
      "width": "360",
      "popper-class": "operateByCommon",
      "placement": "bottom-start",
      "trigger": "click"
    },
    model: {
      value: _vm.showPopover,
      callback: function ($$v) {
        _vm.showPopover = $$v;
      },
      expression: "showPopover"
    }
  }, [_c('i', {
    class: `icon ${_vm.type == 'asRole' ? _vm.selectItem.icon : 'iconfont icon-universal_3-dots'} ${_vm.iconColor}`,
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }), _c('div', {
    staticClass: "btnBox"
  }, [_vm.title ? _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "background-color": "#454549",
      "text-color": "#F1F1F1",
      "collapse": true,
      "popper-append-to-body": false,
      "active-text-color": "#F1F1F1"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, _vm._l(_vm.btnList, function (val, key) {
    return _c('div', {
      key: key,
      class: {
        'cursor-disable': _vm.State.audioMatrixEnable && (val === 'startPrivateConversation' || val === 'cancelPrivateConversation')
      }
    }, [typeof val == 'string' ? _c('el-menu-item', {
      class: `${_vm.activeRole == val ? _vm.activeBg : ''} ${_vm.praivateBg[val]} ${_vm.greenBg}`,
      attrs: {
        "index": val
      }
    }, [_c('i', {
      class: _vm.btnText[val].icon,
      style: {
        'color': _vm.State.partyTag == _vm.singChannel.id && val == 'CancelTag' ? '#33aa50' : ''
      }
    }), _vm._v(" " + _vm._s(_vm.$t(`btnText.${val}.text`)) + " "), val === 'mainwindow' || val === 'unMainwindow' ? _c('span', {
      staticClass: "m_l_5",
      style: {
        color: '#909090'
      }
    }, [_vm._v(_vm._s(_vm.$t('mainWindow.dobluClick')))]) : _vm._e(), _c('el-tooltip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.btnText[val].text == 'Tag as Main Window',
        expression: "btnText[val].text=='Tag as Main Window'"
      }],
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.$t('operationBtn.tagExplain'),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "iconfont icon-help2",
      staticStyle: {
        "margin-top": "-4px",
        "margin-left": "-4px"
      }
    })]), _c('el-tooltip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.btnText[val].text == 'Cancel Tag',
        expression: "btnText[val].text=='Cancel Tag'"
      }],
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.$t('operationBtn.tagExplain'),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "iconfont icon-help2",
      staticStyle: {
        "margin-top": "-4px",
        "margin-left": "-4px"
      }
    })])], 1) : _c('el-submenu', {
      attrs: {
        "popper-class": "menuByCommon",
        "index": val.key
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: _vm.btnText[val.key].icon
    }), _vm._v(_vm._s(_vm.$t(`btnText.${val.key}.text`)))]), _vm._l(val.children, function (value, index) {
      return _c('el-menu-item', {
        key: index,
        class: `${_vm.activeRole == val ? _vm.activeBg : ''} ${_vm.activeRole == value ? _vm.activeBg : ''} ${_vm.praivateBg[value]} ${_vm.greenBg[value]}`,
        attrs: {
          "index": value
        }
      }, [_c('i', {
        class: _vm.btnText[value].icon
      }), _vm._v(_vm._s(_vm.$t(`btnText.${value}.text`)) + " ")]);
    })], 2)], 1);
  }), 0)], 1)]), _vm.setNameInfo.show ? _c('user-setting', {
    attrs: {
      "info": _vm.setNameInfo
    },
    on: {
      "setNickName": _vm.setNickName
    }
  }) : _vm._e(), _vm.privateInfoTips.show ? _c('TipsDailog', {
    staticClass: "private",
    attrs: {
      "info": _vm.privateInfoTips
    },
    on: {
      "save": function ($event) {
        return _vm.privateConversationFn('startPrivateConversation', 'command');
      }
    }
  }) : _vm._e(), _vm.removeInfoTips.show ? _c('TipsDailog', {
    attrs: {
      "info": _vm.removeInfoTips
    },
    on: {
      "save": function ($event) {
        return _vm.removeFn('removeParticipant', 'command');
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };